import { Box, useTheme } from "@mui/material";
import HamMenuIcon from "../../../../media/images/icons/hambergerMenu";
import { useAppDispatch, useAppSelector } from "../../../../hooks/useRedux";
import { setOpenAuthSidebar } from "../../../../redux/features/settingSlice";
import CustomButton from "../../../components/CustomButton";
import { orange } from "@mui/material/colors";

export default function Header() {
  const theme = useTheme();

  const dispatch = useAppDispatch();

  const { hasScroll } = useAppSelector((state) => state.settings);

  return (
    <Box
      sx={{
        height: "60px",
        position: "fixed",
        backgroundColor: "bgColor.grey100",
        maxWidth: "450px",
        top: "0px",
        transition: "box-shadow 500ms",
        boxShadow: hasScroll ? "0px 4px 8px 3px rgba(0,0,0,0.1)" : "none",
        zIndex: 500,
        padding: "0px 8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <CustomButton
        // loading={true}
        onClick={() => dispatch(setOpenAuthSidebar(true))}
        flexDirection="row"
        title="منو"
        justifyContent="space-between"
        bgColor={orange[50]}
        rippleColor={theme.palette.secondary.main}
        fSize="14px"
        fWeight="700"
        px="10px"
        py="8px"
        textColor={"secondary.main"}
        borderColor="secondary.main"
        borderRadius="8px"
        icon1={<HamMenuIcon size={20} color={theme.palette.secondary.main} />}
      />
      {/* <CustomButton
        // loading={true}
        onClick={() => navigate("/notifs")}
        flexDirection="row"
        title="اعلان‌ها"
        justifyContent="space-between"
        bgColor={orange[50]}
        rippleColor={theme.palette.secondary.main}
        fSize="14px"
        fWeight="700"
        px="10px"
        py="8px"
        textColor={"secondary.main"}
        borderColor="secondary.main"
        borderRadius="8px"
        icon2={<NotifsIcon size={20} color={theme.palette.secondary.main} />}
      /> */}
    </Box>
  );
}
